var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaChild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 12.0458L13.253 11.8976L13.0314 11.7192C11.9331 10.8347 11.2 9.50271 11.2 8C11.2 5.36046 13.3605 3.2 16 3.2C18.6395 3.2 20.8 5.36046 20.8 8C20.8 9.50271 20.0669 10.8347 18.9686 11.7192L18.747 11.8976L18.9899 12.0458C20.6642 13.0668 21.8 14.9062 21.8 17V20.3294L21.5738 20.5814L19.8586 22.2955L19.8 22.3541V22.437V28.8H18.2V24V23.8H18H14H13.8V24V28.8H12.2V22.437V22.3541L12.1414 22.2955L10.4262 20.5814L10.2 20.3294V17C10.2 14.9062 11.3358 13.0668 13.0101 12.0458ZM20.1413 19.7046L20.2 19.646V19.563V17C20.2 14.6705 18.3295 12.8 16 12.8C13.6705 12.8 11.8 14.6705 11.8 17V19.562V19.6447L11.8584 19.7033L12.2954 20.1413L12.354 20.2H12.437H19.562H19.6447L19.7033 20.1416L20.1413 19.7046ZM19.2 8C19.2 6.22154 17.7785 4.8 16 4.8C14.2215 4.8 12.8 6.22154 12.8 8C12.8 9.77846 14.2215 11.2 16 11.2C17.7785 11.2 19.2 9.77846 19.2 8Z",
    fill: "#5D5D5D",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaChild);
export default __webpack_public_path__ + "static/media/la_child.fce3f157bae80ae77300ac2580c3f3cf.svg";
export { ForwardRef as ReactComponent };